import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserMinus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { VipSearch } from "@/pages/admin/VipSearch";
import { api, brl, formatError } from "@/lib/api";

export default function AdminVips() {
  const [list, setList] = useState([]);
  const [removing, setRemoving] = useState(null);

  const load = () => api.get("/admin/vips").then((r) => setList(r.data)).catch((e) => toast.error(formatError(e)));
  useEffect(() => { load(); }, []);

  const confirmRemove = async () => {
    try {
      await api.delete(`/admin/vips/${removing.user_id}`);
      toast.success("Perfil VIP removido");
      load();
    } catch (e) {
      toast.error(formatError(e));
    }
    setRemoving(null);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight" data-testid="vips-title">Clientes VIP</h1>
        <p className="text-slate-500">Clientes VIP veem 10% de desconto nos produtos marcados na coluna Cliente VIP e pagam por Pix ou cartão.</p>
      </div>
      <VipSearch onAdded={load} />
      <div className="overflow-x-auto rounded-md border border-slate-200 bg-white">
        <Table data-testid="admin-vips-table">
          <TableHeader>
            <TableRow><TableHead>Cliente VIP</TableHead><TableHead>Contato</TableHead><TableHead>Pedidos</TableHead><TableHead>Total pago</TableHead><TableHead /></TableRow>
          </TableHeader>
          <TableBody>
            {list.map((r) => (
              <TableRow key={r.user_id} data-testid={`vip-row-${r.user_id}`}>
                <TableCell className="font-semibold">{r.name}</TableCell>
                <TableCell><p className="text-sm">{r.email}</p><p className="text-xs text-slate-500">{r.phone}</p></TableCell>
                <TableCell className="font-mono">{r.orders_count}</TableCell>
                <TableCell className="font-mono">{brl(r.paid_total)}</TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="icon" onClick={() => setRemoving(r)} aria-label="Remover perfil VIP" data-testid={`btn-remove-vip-${r.user_id}`}><UserMinus className="h-4 w-4 text-red-500" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {list.length === 0 && <p className="p-10 text-center text-sm text-slate-500" data-testid="no-vips">Nenhum cliente VIP cadastrado.</p>}
      </div>
      <AlertDialog open={!!removing} onOpenChange={(o) => !o && setRemoving(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Remover perfil VIP?</AlertDialogTitle>
            <AlertDialogDescription>{removing?.name} volta a comprar com preço normal. A conta e os pedidos continuam salvos.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="btn-cancel-remove-vip">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={confirmRemove} className="bg-red-600 hover:bg-red-700" data-testid="btn-confirm-remove-vip">Remover</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
